/*
 * @Author: 范向玲
 * @Date: 2023-05-30 10:37:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-14 10:17:16
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\reservesLibrary\manage\tableConfig.js
*/
import config from '@/config/config';

const screenOperationConf = [1,];

const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'commodity',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '单位',
    dataIndex: 'unit',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '开始时间',
    dataIndex: 'minYear',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '结束时间',
    dataIndex: 'maxYear',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '描述',
    dataIndex: 'description',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width:  240,
  },
];
/**
 * 储产销 数管 矿种排序
 */
const sortTableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'commodity',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    // width: 180,
  },
];
const tableData1 = [
  {
    id: '1',
    propName: '金矿',
  },
  {
    id: '2',
    propName: '金矿',
  },
];

export {
  tableConfig, tableData1,sortTableConfig,
};
